
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 133158"}},[_c('path',{attrs:{"data-name":"Path 150791","d":"M15.1 12.066l1.09.879a2.732 2.732 0 01.562-.07 3.352 3.352 0 013.338 3.164l1.09.844a3.874 3.874 0 00.07-.633 4.486 4.486 0 00-4.5-4.5 4.2 4.2 0 00-1.65.316zM16.75 23c-3.762 0-7.172-2.531-8.965-6.574 0-.035-.035-.141-.035-.176a.8.8 0 01.035-.141 12.091 12.091 0 011.652-2.777l-.879-.7a15.378 15.378 0 00-1.828 3.02 3.018 3.018 0 00-.105.6 3.018 3.018 0 00.105.6c1.934 4.324 5.7 7.277 10.02 7.277a9.679 9.679 0 004.75-1.27l-.984-.773A8.251 8.251 0 0116.75 23zm0-13.5c3.762 0 7.172 2.531 8.965 6.574 0 .035.035.141.035.176a.8.8 0 01-.035.141 12.091 12.091 0 01-1.653 2.777l.879.7a15.378 15.378 0 001.828-3.02 3.018 3.018 0 00.105-.6 3.018 3.018 0 00-.105-.6c-1.934-4.324-5.7-7.277-10.02-7.277A9.679 9.679 0 0012 9.641l.984.773A8.251 8.251 0 0116.75 9.5zm0 11.25a4.2 4.2 0 001.65-.316l-1.09-.879a2.732 2.732 0 01-.562.07 3.352 3.352 0 01-3.34-3.164l-1.09-.844a3.874 3.874 0 00-.07.633 4.486 4.486 0 004.502 4.5zm11.039 3.48L6.414 7.356a.6.6 0 00-.809.105.6.6 0 00.105.809l21.376 16.875a.678.678 0 00.352.105.619.619 0 00.457-.211.6.6 0 00-.106-.809z","fill":"#4c535f"}})])])
          )
        }
      }
    